import { render, staticRenderFns } from "./PersistCargaTempView.vue?vue&type=template&id=136bf265&"
import script from "./PersistCargaTempView.vue?vue&type=script&lang=ts&"
export * from "./PersistCargaTempView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports